import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { ApplicantReadMoreText } from '../../ApplicantReadMoreText'
import {
  APPLICANT_IDENTITY_MESSAGE_CLAMP_LINES,
  QA_NAME_APPLICANT_IDENTITY_MESSAGE,
} from '../ApplicantIdentityWidget.constants'
import {
  getApplicantIdentityMessageValue,
  getIsApplicantMessageMasked,
} from '../ApplicantIdentityWidget.utils'

import * as styles from './ApplicantIdentityWidgetMessage.module.css'

function ApplicantIdentityWidgetMessage() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  return (
    <>
      <Text isSecondary className={styles.label}>
        {t('RentalPortal.ApplicantProfileIdentityMessageLabelKey')}
      </Text>
      <ApplicantReadMoreText
        isMuted={getIsApplicantMessageMasked(applicantData)}
        maxLines={APPLICANT_IDENTITY_MESSAGE_CLAMP_LINES}
        qaName={QA_NAME_APPLICANT_IDENTITY_MESSAGE}
        text={getApplicantIdentityMessageValue({ applicantData, t })}
      />
    </>
  )
}

export default ApplicantIdentityWidgetMessage
